import { apiService } from "@/_services";

/**
 * Retrieves the spot table price for etf, from an API call.
 *
 * @returns {Promise<object>} A promise that resolves to the spot price data for the specified etf.
 * @throws {Error} If the API request fails or the asset number is invalid.
 */
export function getETFsTable(assetList) {
  // Define the API request parameters for fetching spot price data.
  const params = {
    method: "GET", // HTTP method for the request.
    endpoint: "etfs_table", // API endpoint for commodity spot price data.
    content_type: "application/json", // Expected content type for the response.
    query_params: {
      format: "json", // Response format (JSON).
      assets: encodeURIComponent(JSON.stringify(assetList))
    }
  };

  // Fetch the spot price data from the API using the apiService.
  return apiService.getAll(params);
}
